import { FancyTabs, Tab } from './FancyTabs';

export { Tab };
export default FancyTabs;
